<template>
  <div class="entity">
    <router-link class="name" :to="{name: 'result-page', query: {q: name}}">{{name}}</router-link>
    <el-tooltip 
    v-for="(event, index) in events" :key="index"
    transition="none"
    :open-delay=120
    :enterable=false
    placement="right">
    <div class="risk-popover" slot="content">
      <div class="risk-title" :class="event.sentiment">{{event.risk}}</div>
      <div class="risk-text" :class="event.sentiment" v-for="(item, index) in event.texts" :key="index">
        {{item}}
      </div>
    </div>
    <span class="event" :class="event.sentiment">{{event.risk}}</span>
    </el-tooltip>
  </div>  
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.entity {
  display: flex;
  align-items: center;
  margin: 4px 0;
  flex-wrap: wrap;
  .name {
    display: inline-block;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 4px;
    background-color: #423f43;
    color: white;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      background-color: #555257;
    }
    &:active {
      background-color: #423f43;
    }
  }
  .event {
    display: inline-block;
    font-size: 12px;
    margin-left: 8px;
    font-family: DIN-Regular;
    cursor: pointer;
    &.positive {
      color: #fe4954;
      &:hover {
        color :#ff2d2d;
        font-family: DIN-Bold;
      }
    }

    &.negative {
      color: #54ce96;
      &:hover {
        color: #32ffb8;
        font-family: DIN-Bold;
      }
    }

    &.neutral {
      color: #a8a8a8;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  padding: 16px 16px 4px 16px !important;
  width: 300px;
  background: #000 !important;
  border: none !important;
  .risk-popover {
    background-color: #000;
    color: #fff;
    .risk-title {
      font-size: 14px;
      font-weight: bold;
      line-height: 16px;
      margin-bottom: 12px;
      &.positive {
        color: #fe4954;
      }
      &.negative {
        color: #54ce96;
      }
      &.neutral {
        color: #a8a8a8;
      }
    }
    .risk-text {
      padding-left: 8px;
      font-size: 12px;
      margin-bottom: 12px;
      line-height: 18px;
      color: #fff;
      &.positive {
        border-left: 2px solid#fe4954;
      }
      &.negative {
       border-left: 2px solid #54ce96;
      }
      &.neutral {
        border-left: 2px solid #a8a8a8;
      }
    }
  }
}
.el-popper[x-placement^="left"] .popper__arrow::after {
  right: 0 !important;
  border-left-color: #000 !important;
}
</style>
